import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import tsic from './modules/tsic'
import dashboard from "./modules/dashboard"
import job from './modules/jobs'
import data from './modules/data'
import index from './modules/indexes'
import statistic from './modules/statistics'
import graphType from './modules/graphTypes'
import site from './modules/site'
import banner from './modules/banner'
import powerBi from "./modules/powerBi";
import DevData from "./modules/DeveloperData";
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    tsic,
    dashboard,
    job,
    data,
    index,
    statistic,
    graphType,
    site,
    banner,
    powerBi,
    DevData,
  },
  // strict: debug,
  plugins: [createPersistedState()]
})
